import { usePool } from '@/components/layout/AppShell'

/* SCAFFOLD — reads pool_ledger. Tracking only: settlement happens off-platform. */
export default function LedgerPage() {
  const pool = usePool()
  return (
    <>
      <header className="border-rule border-b px-6 py-5">
        <h1 className="font-display text-ink text-team">LEDGER</h1>
        <p className="eyebrow mt-1.5">{pool.name}</p>
      </header>
      <p className="text-ink-dim px-6 py-8 text-body">
        Who owes who. Side Action tracks it; you settle it yourselves.
      </p>
    </>
  )
}
